import classnames from 'classnames';

import { forwardRef } from 'react';

import { Icon } from '@/components/icon';

import styles from './checkbox.module.scss';

interface CheckboxProps {
  onChange: (options: { checked: boolean; value?: string }) => void;
  checked?: boolean;
  value?: string;
  id?: string;
  className?: classnames.Argument;
  disabled?: boolean;
  onClick?: (e: React.MouseEvent) => void;
}

export const Checkbox = (props: CheckboxProps) => (
  <input
    type="checkbox"
    id={props.id}
    checked={props.checked ?? false}
    value={props.value}
    disabled={props.disabled}
    onChange={(e) => props.onChange({ checked: e.target.checked, value: e.target.value })}
    onClick={props.onClick}
    className={classnames(styles.checkbox, { [styles.checked]: props.checked }, props.className)}
  />
);

interface CheckboxWithLabelProps extends CheckboxProps {
  children?: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
  onMouseMove?: React.MouseEventHandler<HTMLLabelElement>;
  onMouseOver?: React.MouseEventHandler<HTMLLabelElement>;
  onMouseDown?: React.MouseEventHandler<HTMLLabelElement>;
  style?: React.CSSProperties;
  tabIndex?: number;
}

export const CheckboxWithLabel = forwardRef(function CheckboxWithLabel(
  props: CheckboxWithLabelProps,
  ref?: React.Ref<HTMLLabelElement>,
) {
  const {
    className,
    onClick,
    onMouseMove,
    onMouseOver,
    onMouseDown,
    style,
    tabIndex,
    ...checkboxProps
  } = props;
  return (
    <label
      className={classnames(styles.checkboxWithLabel, className)}
      ref={ref}
      onClick={onClick}
      onMouseMove={onMouseMove}
      onMouseOver={onMouseOver}
      onMouseDown={onMouseDown}
      style={style}
      tabIndex={tabIndex}>
      <Checkbox {...checkboxProps} />
      {props.children}
    </label>
  );
});

interface MixedCheckboxWithLabelProps {
  className?: classnames.Argument;
  disabled?: boolean;
  onClick?: (e: React.MouseEvent) => void;
  onMouseMove?: React.MouseEventHandler<HTMLLabelElement>;
  onMouseOver?: React.MouseEventHandler<HTMLLabelElement>;
  onMouseDown?: React.MouseEventHandler<HTMLLabelElement>;
  style?: React.CSSProperties;
  tabIndex?: number;
  children?: React.ReactNode;
}

export const MixedCheckboxWithLabel = forwardRef(function MixedCheckboxWithLabel(
  props: MixedCheckboxWithLabelProps,
  ref?: React.Ref<HTMLLabelElement>,
) {
  const { className, onClick, onMouseMove, onMouseOver, onMouseDown, style, tabIndex } = props;
  return (
    <label
      className={classnames(styles.checkboxWithLabel, className)}
      ref={ref}
      onClick={onClick}
      onMouseMove={onMouseMove}
      onMouseOver={onMouseOver}
      onMouseDown={onMouseDown}
      style={style}
      tabIndex={tabIndex}>
      <div className={styles.mixedCheckbox}>
        <Icon name="Minus" size={14} color="white" />
      </div>
      {props.children}
    </label>
  );
});
